module.exports = __webpack_public_path__ + "static/media/21b.0cc45bc9.jpg";